import React from "react";
import { SearchOutlined, CloseOutlined } from "@ant-design/icons";
import "./SearchInput.scss";

const SearchInput = ({
  value,
  onChange,
  placeholder = "Search...",
  onClear,
  className = "",
  style = {},
}) => {
  const handleInputChange = (e) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  const handleClear = () => {
    if (onClear) {
      onClear();
    } else if (onChange) {
      onChange("");
    }
  };

  return (
    <div className={`modern-search-container ${className}`} style={style}>
      <div className="search-input-wrapper">
        <SearchOutlined className="search-icon" />
        <input
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={handleInputChange}
          className="modern-search-input"
        />
        {value && (
          <button
            onClick={handleClear}
            className="clear-search-btn"
            type="button"
            aria-label="Clear search"
          >
            <CloseOutlined />
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchInput;
